import React, { useState, useEffect } from "react";
import { useTheme } from "../../context/ThemeContext";
import { MdModeEdit } from "react-icons/md";
import { getTutorInformation, editTutor } from "../../api/api";
import LoaderModal from "../../components/LoaderModal";

const TeacherSettings = () => {
    const { themeStyles } = useTheme();
    const [tutorData, setTutorData] = useState({
        name: "",
        email: "",
        phone: "",
        subject: "",
        department: "",
        profilePic: "",
    });
    const [loader, setLoader] = useState(false);

    useEffect(() => {
        getTutorInfo();
    }, []);

    const getTutorInfo = async () => {
        try {
            setLoader(true);
            const tutorId = localStorage.getItem("tutorId")
            const response = await getTutorInformation(tutorId);
            setTutorData({
                name: response.tutor.name,
                email: response.tutor.email,
                phone: response.tutor.phone,
                subject: response.tutor.subject,
                department: response.tutor.department,
                profilePic: response.tutor.profilePicture ?? "https://www.w3schools.com/w3images/avatar2.png"
            })
        } catch (error) {
            alert(error.message)
        } finally {
            setLoader(false);
        }

    };

    // Function to handle input changes
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setTutorData((prevData) => ({
            ...prevData,
            [name]: value,
        }));
    };

    // Function to handle profile picture upload
    const handleProfilePicChange = (e) => {
        const file = e.target.files[0];
        if (file) {
            const reader = new FileReader();
            reader.onload = (event) => {
                setTutorData((prevData) => ({
                    ...prevData,
                    profilePic: event.target.result,
                }));
            };
            reader.readAsDataURL(file);
        }
    };

    // Function to save changes
    const handleSaveChanges = async () => {
        try {
            const response = await editTutor(localStorage.getItem("tutorId"), {
                name: tutorData.name,
                email: tutorData.email,
                phone: tutorData.phone,
                subject: tutorData.subject,
                department: tutorData.department,
                profilePicture: tutorData.profilePic
            })
            localStorage.setItem("tutorProfile", tutorData.profilePic)
            alert("Changes saved successfully!");
        } catch (error) {
            alert("Something went wrong, Please try again later");
            console.log("error", error);
        }
    };

    return (
        <div
            className="min-h-screen flex flex-col items-center"
            style={{ backgroundColor: themeStyles.background, color: themeStyles.text }}
        >
            {loader && <LoaderModal />}
            <div className="w-full max-w-4xl p-6">
                {/* Header Section */}
                <div
                    className="p-4 rounded-lg shadow-md flex items-center"
                    style={{ backgroundColor: themeStyles.cardBackground }}
                >
                    <div className="relative">
                        <img
                            src={tutorData.profilePic || 'https://www.w3schools.com/w3images/avatar2.png'}
                            alt="Profile"
                            className="w-24 h-24 rounded-full object-contain bg-white p-1"
                        />
                        <label
                            htmlFor="profilePic"
                            className="absolute bottom-0 right-0 bg-primary text-white text-xs px-2 py-2 rounded-full cursor-pointer"
                            style={{
                                backgroundColor: themeStyles.primaryColor,

                            }}
                        >
                            <MdModeEdit />
                        </label>
                        <input
                            id="profilePic"
                            type="file"
                            className="hidden"
                            accept="image/*"
                            onChange={handleProfilePicChange}
                        />
                    </div>
                    <div className="ml-6">
                        <p className="text-2xl font-bold my-3">{tutorData.name}</p>
                        <p className="text-sm">{tutorData.subject} | {tutorData.department}</p>
                    </div>
                </div>

                {/* Editable Personal Details */}
                <div
                    className="mt-6 p-4 rounded-lg shadow-md"
                    style={{ backgroundColor: themeStyles.cardBackground }}
                >
                    <h2 className="text-xl font-semibold mb-4">Personal Details</h2>
                    <form className="grid grid-cols-2 gap-4">
                        <div>
                            <label className="font-medium">Name</label>
                            <input
                                type="text"
                                name="name"
                                value={tutorData.name}
                                onChange={handleInputChange}
                                className="w-full mt-1 p-2 border rounded-md"
                                style={{
                                    background: themeStyles.cardContentBackground,
                                    color: themeStyles.text,
                                    border: `1px solid ${themeStyles.text}`,
                                }}
                            />
                        </div>
                        <div>
                            <label className="font-medium">Email</label>
                            <input
                                type="email"
                                name="email"
                                value={tutorData.email}
                                onChange={handleInputChange}
                                className="w-full mt-1 p-2 border rounded-md"
                                style={{
                                    background: themeStyles.cardContentBackground,
                                    color: themeStyles.text,
                                    border: `1px solid ${themeStyles.text}`,
                                }}
                            />
                        </div>
                        <div>
                            <label className="font-medium">Phone</label>
                            <input
                                type="tel"
                                name="phone"
                                value={tutorData.phone}
                                onChange={handleInputChange}
                                className="w-full mt-1 p-2 border rounded-md"
                                style={{
                                    background: themeStyles.cardContentBackground,
                                    color: themeStyles.text,
                                    border: `1px solid ${themeStyles.text}`,
                                }}
                            />
                        </div>
                        <div>
                            <label className="font-medium">Subject</label>
                            <input
                                type="text"
                                name="subject"
                                value={tutorData.subject}
                                onChange={handleInputChange}
                                className="w-full mt-1 p-2 border rounded-md"
                                style={{
                                    background: themeStyles.cardContentBackground,
                                    color: themeStyles.text,
                                    border: `1px solid ${themeStyles.text}`,
                                }}
                            />
                        </div>
                        <div>
                            <label className="font-medium">Department</label>
                            <input
                                type="text"
                                name="department"
                                value={tutorData.department}
                                onChange={handleInputChange}
                                className="w-full mt-1 p-2 border rounded-md"
                                style={{
                                    background: themeStyles.cardContentBackground,
                                    color: themeStyles.text,
                                    border: `1px solid ${themeStyles.text}`,
                                }}
                            />
                        </div>
                    </form>
                </div>

                {/* Save Button */}
                <div className="flex justify-end mt-6">
                    <button
                        className="py-2 px-6 rounded-md shadow-md font-semibold"
                        style={{ backgroundColor: themeStyles.primaryColor, color: "#FFF" }}
                        onClick={handleSaveChanges}
                    >
                        Save Changes
                    </button>
                </div>
            </div>
        </div>
    );
};

export default TeacherSettings;
